/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IListSolicitacoesDto, IPaginationDto } from "../../../Dtos/Comercial/Solicitacoes/SolicitacoesDtos";
import { IToastOpcoes, Toast } from "../../../Components/Toast/Toast";
import ApiService from "../../../Config/ApiConfig";
import { ActionButton, Card, CardActions, CardField, CardView } from "../../../Components/CardView/CardView";
import { Edit } from "lucide-react";
import { credencialTemAcesso } from "../../../Components/Layout/MenuData";
import { Table, TableContainer, Td, Th } from "../../../Components/Table/Table";
import LoadingPage from "../../../Components/Loading/Loading";
import AppLayout from "../../../Components/Layout/Layout";
import { TopActions } from "../../../Components/TopActions/TopActions";
import Pagination from "../../../Components/Pagination/Pagination";

export const ListaSolicitacaoPage = () => {
    const navigate = useNavigate()
    const [sd92s, setSd92s] = useState<IListSolicitacoesDto[]>([])
    const [filter, setFilter] = useState('');
    const [quantity, setQuantity] = useState('13');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [toastOpcoes, setToastOpcoes] = useState<IToastOpcoes>({ type: "info", visible: false, mensagem: "" })

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Licenças" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        buscarSolicitacoes()
    }, [currentPage, quantity, filter])

    const buscarSolicitacoes = async () => {
        try {
            setLoading(true)

            const apiService = new ApiService();

            const sd01s = await apiService.get<IPaginationDto>("/sd92Controller/buscarSolicitacoes", {
                params: {
                    currentPage,
                    qtd: quantity,
                    filter: filter
                }
            })

            const pages = Math.ceil(sd01s.count / Number(quantity));

            setSd92s(sd01s.values)
            setTotalPage(pages)

        } catch (error: any) {
            setToastOpcoes({ type: "error", visible: true, mensagem: `Falha ao buscar solicitações! \n ${error.response.data}` })
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (id: number) => {
        navigate("/solicitacao/" + id)
    };

    const handleFiltrar = (filtro: string, qtd: string) => {
        setFilter(filtro);
        setQuantity(qtd);
    }

    const closeToast = () => {
        setToastOpcoes({ type: "info", visible: false, mensagem: "" })
    }

    const converterStauts = (status: number) => {
        var nomeStatus = ""
        if (status === 0) nomeStatus = "SOLICITADO";
        if (status === 1) nomeStatus = "APROVADO";
        if (status === 2) nomeStatus = "RECUSADO"
        return nomeStatus
    }

    const renderMobileView = () => (
        <CardView>
            {sd92s.map(sd92 => (
                <Card key={sd92.sd92id}>
                    <CardField>
                        <label>Nome do Representante</label>
                        <span>{sd92.sd41nome}</span>
                    </CardField>
                    <CardField>
                        <label>Cliente(CNPJ)</label>
                        <span>{sd92.sd40cnpj}</span>
                    </CardField>
                    <CardField>
                        <label>Nome do Cliente</label>
                        <span>{sd92.sd40nome}</span>
                    </CardField>
                    <CardField>
                        <label>Status</label>
                        <span>{converterStauts(sd92.sd92status)}</span>
                    </CardField>
                    <CardActions>
                        <ActionButton onClick={() => handleEdit(sd92.sd92id!)} disabled={!credencialTemAcesso("licenças", "sd031acessa")}>
                            <Edit size={16} />
                        </ActionButton>
                    </CardActions>
                </Card>
            ))}
        </CardView>
    );

    const renderDesktopView = () => (
        <TableContainer>
            <Table>
                <thead>
                    <tr>
                        <Th>#</Th>
                        <Th>representante</Th>
                        <Th>Cliente(CNPJ)</Th>
                        <Th>Nome do cliente</Th>
                        <Th>Status</Th>
                        <Th>Operações</Th>
                    </tr>
                </thead>
                <tbody>
                    {sd92s.map(sd92 => (
                        <tr key={sd92.sd92id}>
                            <Td>{sd92.sd92id}</Td>
                            <Td>{sd92.sd41nome}</Td>
                            <Td>{sd92.sd40cnpj}</Td>
                            <Td>{sd92.sd40nome}</Td>
                            <Td>{converterStauts(sd92.sd92status)}</Td>
                            <Td >
                                <ActionButton onClick={() => handleEdit(sd92.sd92id!)} disabled={!credencialTemAcesso("licenças", "sd031acessa")}>
                                    <Edit size={16} />
                                </ActionButton>
                            </Td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </TableContainer>
    );

    if (loading) {
        return (
            <LoadingPage />
        )
    }

    return (
        <AppLayout>
            <Toast
                isVisible={toastOpcoes.visible}
                message={toastOpcoes.mensagem}
                onClose={closeToast}
                type={toastOpcoes.type}
            />
            <TopActions
                disabled
                filter={filter}
                quantity={quantity}
                handleAddNew={() => { }}
                filtrar={handleFiltrar}
            />
            {isMobile ? renderMobileView() : renderDesktopView()}

            <Pagination
                currentPage={currentPage}
                totalPages={totalPage}
                onPageChange={setCurrentPage}
            />
        </AppLayout>
    );
}